module.exports = __webpack_public_path__ + "img/6.e13e7d23.png";